module.exports = __webpack_public_path__ + "static/media/welcome-3.f62d3dcf.mp3";